import React, { FC, useContext, useEffect, useState } from 'react'
import { Column } from 'react-table'
import { t } from '@lingui/macro'

import TableExtendedOld from '../../../../components/common/table-extended-old/TableExtendedOld'
import Loader from '../../../../components/common/loader/Loader'
import Tooltip from '../../../../components/common/tooltip/Tooltip'
import { ManageCampaignContext } from '../../ManageCampaignPage'

import { LinkableUserAvatar } from '../../../../components/common/user/linkable-user-avatar/LinkableUserAvatar'
import { useCampaignImmediateAudienceTableQuery } from './CampaignImmediateAudienceTable.codegen'
import { Box } from 'front-end/src/components'

interface IProps {
  campaignId: number
}

const CampaignImmediateAudienceTable: FC<IProps> = (props) => {
  const { campaign, loading: loadingCampaign } = useContext(
    ManageCampaignContext
  )

  const { campaignId } = props
  const [tableFilters, setTableFilters] = useState({
    page: 1,
    limit: 20,
    search: ''
  })

  const { data, refetch, loading } = useCampaignImmediateAudienceTableQuery({
    variables: {
      id: campaignId,
      offset: (tableFilters.page - 1) * tableFilters.limit,
      ...tableFilters
    }
  })
  useEffect(() => {
    refetch() // this is needed for when the campaign is activated-the audience get's populated on the backend and we need to refetch
  }, [campaign.is_active])

  if (!data || loadingCampaign) {
    return <Loader />
  }

  const tableColumns: Column[] = [
    {
      Header: '',
      sortable: false,
      maxWidth: 54,
      Cell: (row) => {
        return <LinkableUserAvatar user={row.original} />
      }
    },
    {
      id: 'display_name',
      Header: t`Name`,
      Cell: (row) => (
        <Tooltip text={row.original.email}>
          <strong className="dark">{row.original.display_name}</strong>
        </Tooltip>
      )
    },
    {
      Header: t`Engagement`,
      maxWidth: 100,
      sortable: false,
      className: 'greenText',
      accessor: 'analytic_events_count'
    }
  ]

  let pagesCount
  const { admin } = data
  if (admin && admin.campaign) {
    pagesCount = Math.ceil(
      (admin.campaign?.immediateUsersCount ?? 0) / tableFilters.limit
    )
  } else {
    pagesCount = 1
  }

  return (
    <Box className="CampaignAudience__table" mt="16px">
      <TableExtendedOld
        loading={loading}
        manual
        data={admin && admin.campaign && admin.campaign.immediateUsers}
        tableHeader={t`Audience`}
        columns={tableColumns}
        className="-highlight AnalyticsTable"
        defaultPageSize={tableFilters.limit}
        showPageSizeOptions={false}
        showSearchFilter
        resizable={false}
        minRows={5}
        pages={pagesCount}
        sortable={false}
        onPageChange={(newPage) => {
          setTableFilters((prevState) => {
            return {
              ...prevState,
              page: newPage + 1
            }
          })
        }}
        page={tableFilters.page - 1}
        onSearchChange={(searchVal) => {
          setTableFilters((prevState) => {
            return {
              ...prevState,
              search: searchVal
            }
          })
        }}
      />
    </Box>
  )
}

export default CampaignImmediateAudienceTable
